import React from 'react';
import styled from 'styled-components';

const warningIcon = 'https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/warning.svg';
import Button from '../Button';
import ContainerModal from '../ContainerModal';
import { useAnalytics } from '../../hooks/useAnalytics';
import { useScheduleContext } from '../../contexts/ScheduleContext';
import { useServiceContext } from '../../contexts/ServiceContext';
import { FirebaseEvents } from '../../utils/enums/firebase-events';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;

  @media (min-width: 900px) {
    justify-content: space-between;
  }
`;

const InfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;

  & .title {
    font-weight: 500;
    font-size: 24px;
    color: var(--color-gray-500);
    line-height: 32px;
    text-align: center;
  }

  @media (min-width: 900px) {
    padding: 0 40px;
  }
`;

const Center = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;

  @media (min-width: 900px) {
    padding-bottom: 32px;
  }
`;

type ModalConfirmCloseProps = {
  visible: boolean;
  onCancelClose: () => void;
  onConfirmClose: () => void;
};
export const ModalConfirmClose: React.FC<ModalConfirmCloseProps> = ({ visible, onCancelClose, onConfirmClose }) => {
  const { logEvent } = useAnalytics();

  const { selectedItem } = useScheduleContext();
  const { selectedService } = useServiceContext();

  return (
    <ContainerModal
      visible={visible}
      onClose={onCancelClose}
      withoutCloseButton={true}
      childrenFooter={
        <>
          <Button
            disabled={!visible}
            type="button"
            title="Sim"
            onClick={() => {
              logEvent({
                eventName: FirebaseEvents.schedule_abort,
                eventParams: {
                  product_id: selectedItem?.productId ?? '',
                  product_name: selectedItem?.productName ?? '',
                  service_id: selectedService?.id ?? '',
                  service_name: selectedService?.name ?? ''
                }
              });

              onConfirmClose();
            }}
          />
          <Button disabled={!visible} type="button" title="Não" tertiary onClick={onCancelClose} />
        </>
      }
    >
      <Container>
        <InfoContainer>
          <Center>
            <img src={warningIcon} alt="warning" />
            <h3 className="title">Deseja abandonar o agendamento?</h3>
          </Center>
        </InfoContainer>
      </Container>
    </ContainerModal>
  );
};
